import { useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import { toast } from "react-hot-toast";
import { Loader2 } from "lucide-react";

interface Beneficiary {
  id: string;
  name: string;
  relation: string;
}

interface SelectDropdownProps {
  beneficiaries: Beneficiary[];
  onAccessCreated: () => void;
}

export default function SelectDropdown({ beneficiaries, onAccessCreated }: SelectDropdownProps) {
  const [selectedId, setSelectedId] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const handleSendAccess = async () => {
    if (!selectedId) return;
    setLoading(true);

    const { error } = await supabase.from("beneficiaries_access").insert({
      beneficiary_id: selectedId,
      access_token: crypto.randomUUID(),
      expires_at: new Date(new Date().setMonth(new Date().getMonth() + 1)),
    });

    setLoading(false);

    if (error) {
      toast.error("Erreur lors de la création de l'accès.");
    } else {
      toast.success("Accès créé avec succès !");
      onAccessCreated();
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <select
        value={selectedId}
        onChange={(e) => setSelectedId(e.target.value)}
        className="p-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 bg-white text-gray-800"
      >
        <option value="">Choisissez un héritier</option>
        {beneficiaries.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name} ({b.relation})
          </option>
        ))}
      </select>

      <button
        onClick={handleSendAccess}
        disabled={!selectedId || loading}
        className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-6 rounded-full transition flex items-center justify-center gap-2"
      >
        {loading && <Loader2 className="animate-spin" size={20} />}
        Créer l'accès
      </button>
    </div>
  );
}
